import { MENU_CLOSE, MENU_OPEN } from '@store/types'
import shortly from 'vuex-shortly'

const state = {
  open: false
}

const getters = {
  [MENU_OPEN]: 'open'
}

const mutations = {
  [MENU_OPEN]: 'open'
}

const actions = {
  [MENU_OPEN]: ({ commit }) => commit(MENU_OPEN, true),
  [MENU_CLOSE]: ({ commit }) => commit(MENU_OPEN, false)
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/menu.js